/**
 * Shop filters — mobile drawer z portalem do <body>.
 *
 * Desktop (>768px): pasek filtrów statycznie w `.hn-shop-filters`, JS bezczynny.
 * Mobile (≤768px): klik "Filtry" → off-canvas drawer z prawej + overlay.
 *
 * PORTAL: `.hn-shop-filters` siedzi głęboko w `.hn-shop__main` — `position:fixed`
 * drawera był uwięziony w stacking-context pod sticky headerem. Na mobile JS
 * przenosi `__overlay` + `__body` jako direct children <body> → root stacking
 * context → drawer paint'uje się nad navbarem. Anchor comment nodes pamiętają
 * oryginalną pozycję żeby przywrócić na desktop (resize).
 *
 * Zamknięcie: overlay click / × / "Pokaż wyniki" / Escape.
 */
export function initShopFilters() {
    const filters = document.querySelector('.hn-shop-filters');
    if (!filters) return;

    const toggle  = filters.querySelector('.hn-shop-filters__toggle');
    const overlay = filters.querySelector('.hn-shop-filters__overlay');
    const body    = filters.querySelector('.hn-shop-filters__body');
    if (!toggle || !overlay || !body) return;

    const mq = window.matchMedia('(max-width: 768px)');

    // Anchor comments — placeholdery oryginalnej pozycji w DOM.
    const overlayAnchor = document.createComment('hn-filters-overlay');
    const bodyAnchor    = document.createComment('hn-filters-body');
    let portaled = false;

    const portalToBody = () => {
        if (portaled) return;
        overlay.parentNode.insertBefore(overlayAnchor, overlay);
        body.parentNode.insertBefore(bodyAnchor, body);
        document.body.appendChild(overlay);
        document.body.appendChild(body);
        portaled = true;
    };

    const restoreToFilters = () => {
        if (!portaled) return;
        overlayAnchor.parentNode.insertBefore(overlay, overlayAnchor);
        bodyAnchor.parentNode.insertBefore(body, bodyAnchor);
        overlayAnchor.remove();
        bodyAnchor.remove();
        portaled = false;
    };

    const isOpen = () => body.classList.contains('is-open');

    const setOpen = (open) => {
        filters.setAttribute('data-open', open ? 'true' : 'false'); // arrow icon
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        overlay.classList.toggle('is-open', open);
        body.classList.toggle('is-open', open);
        document.body.classList.toggle('hn-filters-open', open);
    };

    // Sync portal state z viewportem.
    const syncPortal = () => {
        if (mq.matches) {
            portalToBody();
        } else {
            setOpen(false);
            restoreToFilters();
        }
    };
    syncPortal();
    mq.addEventListener('change', syncPortal);

    // Toggle "Filtry"
    toggle.addEventListener('click', () => setOpen(!isOpen()));

    // Overlay click → zamknij
    overlay.addEventListener('click', () => setOpen(false));

    // × i "Pokaż wyniki" wewnątrz drawera
    body.addEventListener('click', (e) => {
        if (e.target.closest('[data-hn-filters-close]')) setOpen(false);
    });

    // Escape → zamknij
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isOpen()) setOpen(false);
    });
}
